// Skeleton loading components for UI placeholders
import SkeletonComponent from 'react-loading-skeleton';
import type { SkeletonProps } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// Generic skeleton wrapper for custom styling
export const Skeleton = ({ style, ...rest }: SkeletonProps) => {
  return <SkeletonComponent {...rest} style={{ ...style, zIndex: 0 }} />;
};

// Skeleton for pagination controls
export const PaginationSkeleton = () => (
  <div className="flex flex-wrap justify-between w-full">
    <Skeleton width={200} height={30} />
    <Skeleton count={6} inline width={50} height={30} className="mr-2" />
  </div>
);

// Skeleton for soft tag table rows
export const SoftTagTableSkeleton = () => (
  <div className="w-full mt-6">
    <Skeleton count={8} height={40} className="my-1" />
  </div>
);

export const BackfillTableSkeleton = () => (
  <div className="w-full mt-6">
    <Skeleton count={3} height={40} className="my-1" />
  </div>
);

export const EditSoftTagSkeleton = () => (
  <div className="w-full mt-6 m-auto">
    <Skeleton count={2} height={50} className="my-2" />
    <div className="w-full flex justify-between">
      <Skeleton count={1} height={50} width={220} className="my-2" />
      <Skeleton count={1} height={50} width={220} className="my-2" />
      <Skeleton count={1} height={50} width={220} className="my-2" />
    </div>

    <div className="w-full flex justify-between">
      <Skeleton count={1} height={50} width={220} className="my-2" />
      <Skeleton count={1} height={50} width={220} className="my-2" />
      <Skeleton count={1} height={50} width={220} className="my-2" />
    </div>
    <Skeleton count={1} height={50} className="my-2" />
    <div className="w-full flex justify-between">
      <Skeleton count={1} height={50} width={380} className="my-2" />
      <Skeleton count={1} height={50} width={380} className="my-2" />
    </div>
    <div className="w-full flex justify-between">
      <Skeleton count={1} height={50} width={380} className="my-2" />
      <Skeleton count={1} height={50} width={380} className="my-2" />
    </div>
  </div>
);
